<template>
  <v-container>
    <v-fade-transition mode="out-in">
      <div v-if="!loading">
        <v-row dense>
          <v-col cols="12">
            <div class="d-flex align-center flex-wrap">
              <h1>Requêtes en cours</h1>
            </div>
          </v-col>
          <template v-if="!requetesEnCours.length">
            <v-col cols="12">
              <p class="text-center">
                Vous n'avez aucune requête en cours pour le moment.
              </p>
            </v-col>
          </template>
          <template v-else>
            <v-col
              cols="12"
              lg="4"
              md="6"
              v-for="(a,index) in requetesEnCours"
              :key="a.requete.numero"
            >
              <a-requete-dashboard-card :value="a" :data-testid="`requete-encours-${index}`"/>
            </v-col>
          </template>
        </v-row>

        <v-row dense align-content="stretch">
          <v-col cols="12">
            <div class="d-flex align-center flex-wrap">
              <h1>Dernières activités</h1>
            </div>
          </v-col>

          <template v-if="!requetesRecentes.length">
            <v-col cols="12">
              <p class="text-center">Vous n'avez aucune activité pour le moment.</p>
            </v-col>
          </template>
          <template v-else>
            <v-col
              cols="12"
              lg="4"
              md="6"
              v-for="(a,index) in requetesRecentes"
              :key="a.requete.numero"
            >
              <a-requete-dashboard-card :value="a" :data-testid="`requete-recente-${index}`"/>
            </v-col>

            <v-col cols="12" lg="4" md="6">
              <v-hover v-slot="{ hover }">
                <v-card
                  outlined
                  :elevation="hover ? 4 : 1"
                  @click="versListeRequetes"
                  style="height: 100%"
                  class="d-flex flex-column justify-space-between"
                  data-testid="liste-requetes"
                >
                  <div>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <strong>Vous souhaitez consulter toutes les requêtes ?</strong>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                  <div>
                    <v-card-actions style="height:42px; !important">
                      <v-hover v-slot="{ hover }">
                        <v-btn data-testid="consulter-requetes" block :outlined="hover" depressed color="primary">
                          Cliquez ici ...
                        </v-btn>
                      </v-hover>
                    </v-card-actions>
                    <v-divider class="mt-1 mb-1" />
                    <v-card-actions
                      class="d-flex justify-center"
                      style="height:42px; !important"
                    >
                    </v-card-actions>
                  </div>
                </v-card>
              </v-hover>
            </v-col>
          </template>
        </v-row>
      </div>
      <v-skeleton-loader v-else loading type="card-heading, actions, card, sentences" />
    </v-fade-transition>
  </v-container>
</template>

<script>
import { principalService } from "@/services";
import { toListeRequete } from "@/routes/requetes";

function compareBool(l, r) {
  if (!!l && !r) {
    return -1;
  } else if (!l && !!r) {
    return 1;
  }
  return 0;
}

export default {
  data() {
    return {
      requetes: [],
      loading: false,
    };
  },

  mounted() {
    this.load();
  },

  computed: {
    requetesEnCours() {
      return this.requetesTriees.filter(r => r.requete.etat === "EN_COURS");
    },
    requetesRecentes() {
      return this.requetes.filter(r => !!r.requete.dateOrdonnancement);
    },
    requetesTriees() {
      return [...this.requetes].sort((l, r) => {
        var pieces = compareBool(!!l.demandesPieces.length, r.demandesPieces.length);

        if (pieces !== 0) return pieces;

        return r.requete.numero.localeCompare(l.requete.numero);
      });
    },
  },

  methods: {
    versListeRequetes() {
      this.$router.push(toListeRequete());
    },
    load() {
      this.loading = true;
      principalService
        .dashboardRequetes()
        .then(({ requetes }) => {
          this.requetes = requetes;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
